import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://codelens.epoch.co/openshield/';

class EventsApiService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      timeout: 30000,
    });

    // Add request interceptor for Cognito token authentication
    this.api.interceptors.request.use(
      (config) => {
        const accessToken = localStorage.getItem('cognito_token');
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        } else {
          // If no token, reject the request
          return Promise.reject(new Error('No authentication token available'));
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Add response interceptor for error handling
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('cognito_token');
          localStorage.removeItem('user_info');
          window.location.href = 'https://codelens.epoch.co/';
        }
        return Promise.reject(error);
      }
    );
  }

  /**
   * Fetch events evolution data for a specific agent
   * @param {string} agentId - The agent ID
   * @param {string} interval - Time interval (default: 30m)
   * @param {number} days - Number of days (default: 30)
   * @returns {Promise} API response
   */
  async getEventsEvolution(agentId, interval = '30m', days = 30) {
    try {
      const response = await this.api.get(`/events/agent/${agentId}/evolution`, {
        params: {
          interval,
          days
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching events evolution:', error);
      throw error;
    }
  }
}

export default new EventsApiService();
